import { Leaf } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export function Logo({ size = "md", showWordmark = true, className = "" }) {
  const { settings } = useSettings();
  const sizes = {
    sm: { box: "w-8 h-8", icon: 16, text: "text-base", img: "h-8" },
    md: { box: "w-10 h-10", icon: 20, text: "text-xl", img: "h-10" },
    lg: { box: "w-14 h-14", icon: 26, text: "text-2xl", img: "h-14" },
  };
  const s = sizes[size] || sizes.md;
  const primary = settings.primary_color || "#0E9F6E";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      {settings.logo_image ? (
        <img src={settings.logo_image} alt={settings.app_name} className={`${s.img} w-auto object-contain`} />
      ) : (
        <div className={`${s.box} rounded-xl flex items-center justify-center shadow-sm text-white`} style={{ backgroundColor: primary }}>
          <Leaf size={s.icon} strokeWidth={2.5} />
        </div>
      )}
      {showWordmark && (
        <div className="leading-tight">
          <div className={`font-extrabold ${s.text} text-foreground`} style={{ fontFamily: `var(--font-heading, 'Manrope'), system-ui, sans-serif` }}>{settings.logo_line1 || "AZHD"}</div>
          <div className="text-[10px] uppercase tracking-[0.25em] font-semibold" style={{ color: primary }}>{settings.logo_line2 || "NUTRITRACK"}</div>
        </div>
      )}
    </div>
  );
}

export default Logo;
